// text: '我的待办',
// const WXTaskList = () => import(/* webpackChunkName: "homePage" */
//   '@/components/workSpace/WXTaskList');

// todo  可能会出问题
//我的发起
// const MYTaskList = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/MYTaskList');

// 我的转移
// const myTransferTaskList = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/myTransferTaskList');


//我的扫描
// const myScanning = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/myScanning');
// const scanningList = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/scanningList');
//我的扫描 关联客户
// const relationCustomer = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/relationCustomer');

// 日历
// const agencyCalendar = () => import( /* webpackChunkName: "homePage" */
//   '@/components/agency/agency');

//裂变
// const fission = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/fission');

// 外呼任务
// const outboundTasks = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/outboundTasks')
// const outCallTypeList = () => import( /* webpackChunkName: "homePage" */
//   '@/components/workSpace/outCallTypeList')

// const searchMyworkBenchPerformances = () => import( /* webpackChunkName: "homePage" */ '@/components/workSpace/myWorkBench')

const workSpace2 = () => import('@/components/workSpace/workSpace2')

// 首页6.7需求
const workbench1 = () => import( /* webpackChunkName: "homePage" */ '@/components/workSpace/workbench/index')

export default [
  // 旧工作台
  {
    path: '/workSpace2',
    name: 'workSpace2',
    meta: {
      belong: ['homePage'],
      text: '工作台',
    },
    component: workSpace2
  },
  // 新首页
  {
    path: '/workSpace',
    name: 'workSpace',
    meta: {
      belong: ['homePage'],
      text: '首页',
    },
    component: workbench1
  },

  // { //图表模式
  //   path: "/myScanning",
  //   meta: {
  //     belong: ['homePage'],
  //     text: '我的扫描',
  //   },
  //   name: 'myScanning',
  //   component: myScanning
  // },
  // { //列表模式
  //   path: "/scanningList",
  //   meta: {
  //     belong: ['homePage'],
  //     text: '我的扫描',
  //   },
  //   name: 'scanningList',
  //   component: scanningList
  // },
  // {
  //   path: "/relationCustomer",
  //   meta: {
  //     belong: ['homePage'],
  //     text: '关联客户',
  //   },
  //   name: 'relationCustomer',
  //   component: relationCustomer
  // },
  // {
  //   path: "/getActionCalendars",
  //   meta: {
  //     belong: ['homePage'],
  //     text: '我的日历',
  //   },
  //   name: 'agencyCalendar',
  //   component: agencyCalendar
  // },
  // { //裂变
  //   path: "/fission",
  //   meta: {
  //     belong: ['homePage'],
  //     text: '裂变',
  //   },
  //   name: 'fission',
  //   component: fission
  // },
  // 外呼任务 outboundTasks
  // {
  //   path: '/outboundTasks',
  //   name: 'outboundTasks',
  //   meta: {
  //     belong: ['homePage'],
  //     text: '外呼任务',
  //   },
  //   component: outboundTasks,
  // },
  // 外呼任务 outboundTasks
  // {
  //   path: '/outCallTypeList',
  //   name: 'outCallTypeList',
  //   meta: {
  //     belong: ['homePage'],
  //     text: '外呼任务',
  //   },
  //   component: outCallTypeList,
  // },
  // {
  //   path: '/searchMyworkBenchPerformances',
  //   name: 'searchMyworkBenchPerformances',
  //   meta: {
  //     belong: ['homePage'],
  //     text: '业绩详情',
  //   },
  //   component: searchMyworkBenchPerformances
  // },
]
